var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#898989",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 9L9 27M9 9l18 18",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/Icon.5fd9dcc7.svg";
export { SvgIcon as ReactComponent };